export default "__VITE_ASSET__BSmCEIOD__"